import React, { useContext, useState } from "react";

import { useSelector } from "react-redux";
import { Redirect } from 'react-router-dom';

import { Card, Row, Col} from "react-bootstrap"
import {useGetClientConnectionsPerMonth, useGetClientConnectionByCompanyType} from '../../hooks/useOfCharts'
import { authGetClient } from "../../actions/auth-action";

import ChartCustomerAccesesPerMonth from "../../components/Charts/Customer/AccessPerMonth"
import ChartAccesesPerMonthStack from "../../components/Charts/AccessesPerMonthStack"
import AccessesPerMonthTotalPai from "../../components/Charts/AccessesPerMonthTotalPai"
import ClientHeader from "../../components/Profile/ClientHeader";
import ClientProfileCards from "../../components/ClientProfileCards/ClientProfileCards";
import { useGetClientProducts } from "../../hooks/useOfClient";
import AuthVerify from "../../components/AuthVerify";
import MainAppContext from "../../MainAppContext";
import PropTypes from 'prop-types';


const ProfileClient = (props) => {
  
  const { user: currentAuth } = useSelector((state) => state.auth);
  const contextSite = useContext(MainAppContext);

  const clientId = props.location.state !== null ? props.location.state.clientId : authGetClient();

  const [chartDataClientConnectionsPerMonth, setChartDataClientConnectionsPerMonth] = useState(null);        
  useGetClientConnectionsPerMonth(clientId, chartDataClientConnectionsPerMonth, setChartDataClientConnectionsPerMonth);

  const [chartDataClientConnectionsPerMandanteAndEEECC, setChartDataClientConnectionsPerMandanteAndEEECC] = useState(null);        
  useGetClientConnectionByCompanyType(clientId, chartDataClientConnectionsPerMandanteAndEEECC, setChartDataClientConnectionsPerMandanteAndEEECC);

  const [clientProcucts, setClientProcucts] = useState(null);        
  useGetClientProducts(clientId, clientProcucts, setClientProcucts);

  if (contextSite.clientId !== clientId && contextSite.onlyObserver) {
    return <Redirect to="/profile" />;
  }
  else if (!currentAuth.profile.includes("sAdmin") || !currentAuth.profile.includes("Admin")) {
    return <Redirect to="/login" />;
  }

  return (
    <>
      <AuthVerify currentToken={currentAuth} />
      {clientId &&
        <Row>
          <Col sm={12} md={12} lg={12} xl={12}>
              <ClientHeader clientId={ clientId } showEditProfile={true} showManageSecurity={true} />
          </Col>
        </Row>   
      }

      <Row className="justify-content-center">
        { clientId && clientProcucts?.map((item) =>
            <ClientProfileCards key={item.index} clientId={ clientId }  productId={ item.productId } />
        )}
      </Row>
      <Row>
        <Col xl={12}>
          <ChartCustomerAccesesPerMonth chartData={chartDataClientConnectionsPerMonth} />
        </Col>
        <Col xl={12}>
          <Card style={{height:"300px"}} className="rounded-3">
                <Card.Body className="col-xs-12">
                    <Row>
                        <Col xl={4}>
                            <AccessesPerMonthTotalPai chartData={ chartDataClientConnectionsPerMandanteAndEEECC } />
                        </Col>
                        <Col xl={8}>
                            <ChartAccesesPerMonthStack chartData={ chartDataClientConnectionsPerMandanteAndEEECC } />
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </Col>
      </Row>    
    </>
  );
};
ProfileClient.propTypes = {
  location: PropTypes.object.isRequired,
};
export default ProfileClient;
